import { makeVar } from '@apollo/client';
import { CategoryModel } from '../categories/models';

export const selectedCategoryVar = makeVar<CategoryModel['id'] | undefined>(undefined);
